import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgIconsModule } from '@ng-icons/core';
import {
  heroArrowUpTray,
  heroBars3,
  heroChevronDown,
  heroExclamationCircle,
  heroMagnifyingGlass,
  heroShoppingCart,
  heroTag,
  heroUser,
  heroXMark,
} from '@ng-icons/heroicons/outline';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { OrgFooterComponent } from './components/org-footer/org-footer.component';
import { MolNavButtonComponent } from './components/mol-nav-button/mol-nav-button.component';
import { OrgInfoCardComponent } from './components/org-info-card/org-info-card.component';
import { OrgLayoutFooterComponent } from './components/org-layout-footer/org-layout-footer.component';
import { OrgLayoutHeaderComponent } from './components/org-layout-header/org-layout-header.component';
import { OrgLayoutSearchComponent } from './components/org-layout-search/org-layout-search.component';
import { OrgSplitScreenComponent } from './components/org-split-screen/org-split-screen.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TempMainLayoutComponent } from './components/temp-main-layout/temp-main-layout.component';
import { TempAuthLayoutComponent } from './components/temp-auth-layout/temp-auth-layout.component';
import { OrgMobileNavigationMenuComponent } from './components/org-mobile-navigation-menu/org-mobile-navigation-menu.component';
import { TempQuoterLayoutComponent } from './components/temp-quoter-layout/temp-quoter-layout.component';
import { OrgLayoutQuoterHeaderComponent } from './components/org-layout-quoter-header/org-layout-quoter-header.component';

import { MolUserMenuComponent } from './components/mol-user-menu/mol-user-menu.component';
import { MolActiveOrderBannerComponent } from './components/mol-active-order-banner/mol-active-order-banner.component';
import { MolCategoryMenuComponent } from './components/mol-category-menu/mol-category-menu.component';
import { AppCommonsModule } from './module-app-commons/app-commons.module';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { PagePrivacyPolicyModule } from './pages/page-privacy-policy/page-privacy-policy.module';
import { PageTermsAndConditionsModule } from './pages/page-terms-and-conditions/page-terms-and-conditions.module';
import { CatalogCommonsModule } from './module-catalog-commons/catalog-commons.module';
import { CoreModule } from './core/core.module';
import { AuthService } from './auth/auth.service';

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,

    OrgLayoutHeaderComponent,
    OrgLayoutQuoterHeaderComponent,
    OrgLayoutFooterComponent,
    OrgLayoutSearchComponent,

    MolActiveOrderBannerComponent,
    MolUserMenuComponent,
    MolCategoryMenuComponent,
    MolNavButtonComponent,

    TempMainLayoutComponent,
    TempAuthLayoutComponent,
    TempQuoterLayoutComponent,

    OrgMobileNavigationMenuComponent,
    OrgFooterComponent,
    OrgSplitScreenComponent,
    OrgInfoCardComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    CoreModule,
    AppCommonsModule,
    CatalogCommonsModule,

    // ============================ PAGES ============================ //
    PagePrivacyPolicyModule,
    PageTermsAndConditionsModule,

    NgIconsModule.withIcons({
      heroArrowUpTray,
      heroBars3,
      heroChevronDown,
      heroExclamationCircle,
      heroMagnifyingGlass,
      heroShoppingCart,
      heroTag,
      heroUser,
      heroXMark,
    }),

    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      messageClass: 'text-paragraph',
    }),
  ],
  providers: [AuthService],
  bootstrap: [AppComponent],
})
export class AppModule {}
